import Chart from 'react-apexcharts'
import restoreImg from '../../assets/restore.png'
import { useTranslation } from "react-i18next"

const LineChart = ({ data, graphOptions, labels, width }) => {
  const { t } = useTranslation('common')
  const options = {
    chart: {
      fontFamily: 'Roboto, Arial, sans-serif',
      foreColor: '#666E7B',
      type: 'line',
      defaultLocale: 'pt',
      locales: [
        {
          name: 'pt',
          options: {
            toolbar: {
              selectionZoom: `${t('dashboard.header.select_period')}`,
              zoomIn: `${t('dashboard.header.zoom_in')}`,
              pan: `${t('dashboard.header.scroll')}`,
              reset: `${t('dashboard.header.reset_zoom')}`,
            },
          },
        },
      ],
      toolbar: {
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: false,
          pan: true,
          reset: `<img src=${restoreImg} width="20">`,
        },
        autoSelected: 'pan',
      },
      zoom: {
        zoomedArea: {
          fill: {
            color: '#E27837',
            opacity: 0.2,
          },
          stroke: {
            curve: 'smooth',
            color: '#E27837',
            opacity: 0.2,
            width: 1,
          },
        },
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      size: 0,
      showNullDataPoints: false,
    },
    xaxis: {
      categories: labels,
      type: 'datetime',
      labels: {
        formatter: function (value, timestamp, opts) {
          return opts.dateFormatter(new Date(timestamp), `dd/MM - HH\\h00`)
        },
        style: {
          fontSize: '14px',
        },
        datetimeUTC: false,
      },
      axisTicks: {
        borderType: 'solid',
        color: '#666E7B',
        height: 12,
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      stepSize: 10,
      labels: {
        show: true,
        style: {
          fontSize: '16px',
          fontWeight: 600,
        },
      },
      decimalsInFloat: 0,
      min: 30,
      max: 100,
    },
    ...graphOptions,
  }

  return (
    <Chart
      options={options}
      series={data}
      type='line'
      height={400}
      width={width}
    />
  )
}

export default LineChart
